// extracted by mini-css-extract-plugin
export default {"description":"description__Mgdg8kGH"};